<template>
  <div ref="root">
    <ak-notification ref="root" v-bind="props" @close="close" />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import {
  notificationNoticeProps,
  noticeProps,
  noticeMixin,
} from '../../mixins/noticeMixin'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-notification-notice :epic=false :type="'info" />
   */
  name: 'AkNotificationNotice',

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    ...notificationNoticeProps,
    ...noticeProps,
  },

  /**
   * @type {Array}
   * @description The list of events that this component can trigger
   */
  emits: ['close'],

  /**
   * @param {Object} props - The properties of the component
   * @param {Object} options - The setup options
   * @param {Function} options.emit - The emit method for triggering events
   * @description Sets up the component and returns an object containing all of the
   * attributes for the component to use.
   */
  setup(props, { emit }) {
    const root = ref(null)

    const mixin = noticeMixin({
      props,
      root,
      emit,
    })

    return {
      ...mixin,
      root,
      props,
    }
  },
})
</script>
